export default (vue)=>{
  vue.directive('has',{
    inserted(el,bindings,vnode){
      let currentTag=bindings.value
      let btnList=vnode.context.$store.state.promiseBtn
      let item=btnList.filter((item)=>{
        return item===currentTag
      })
      if(item.length===0){
        el.parentNode.removeChild(el)
      }
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./static/btnPermission.js
// module id = null
// module chunks = 